import script from "./RegrasAcessoAdministrar.vue?vue&type=script&setup=true&lang=js"
export * from "./RegrasAcessoAdministrar.vue?vue&type=script&setup=true&lang=js"

import "./RegrasAcessoAdministrar.vue?vue&type=style&index=0&id=4beda18b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4beda18b"]])

export default __exports__